import PropTypes from 'prop-types';
import FavoritesContentOnboardingImpl from './favorites-content-onboarding.js';
import MojitoCore from 'mojito/core';

const UIView = MojitoCore.Presentation.UIView;

/**
 * Component responsible for displaying a message when there are no favorite events added.
 *
 * @class FavoritesContentOnboarding
 * @memberof Mojito.Modules.InPlay
 */

/**
 * `FavoritesContentOnboarding` prop types.
 *
 * @property {boolean} closable - Flag defines whether onboarding is closable.
 *
 * @memberof Mojito.Modules.InPlay.FavoritesContentOnboarding
 */
const propTypes = {
    closable: PropTypes.bool,
};

const defaultProps = {
    closable: true,
};

export default UIView(
    'FavoritesContentOnboarding',
    FavoritesContentOnboardingImpl,
    propTypes,
    defaultProps
);
